import { type RealtorUserProfile } from '@aikoa/common'
import { useMutation, useQuery } from '@tanstack/react-query'
import { useUserId } from '~/components/user/SessionProvider'
import { getCurrentUserProfile } from '~/data/user/readUserProfile'
import { updateUserProfile, type UpdateUserProfilePayload } from '~/data/user/writeUserProfile'
import { queryClient, trpc } from '~/lib/trpc'

export const useUpdateUserProfile = () => {
  return useMutation({
    mutationFn: (payload: UpdateUserProfilePayload) => updateUserProfile(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['userProfile'] })
    },
  })
}

export const isUserProfileComplete = (profile?: RealtorUserProfile) => {
  if (!profile) {
    return false
  }

  return !!profile.name && !!profile.data?.avatar_url && !!profile.email
}

export function useUserProfile() {
  const userId = useUserId()

  return useQuery({
    queryKey: ['userProfile', userId],
    queryFn: () => (userId ? getCurrentUserProfile() : null),
    enabled: !!userId,
  })
}

export function useUserProfileById(userId: string) {
  return useQuery(trpc.users.getRealtorProfileById.queryOptions({ userId }))
}
